import type { SVGProps } from 'react';

const SvgLockClock = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <path d="M18 11c.7 0 1.37.1 2 .29V8h-3V6.21c0-2.61-1.91-4.94-4.51-5.19A5.01 5.01 0 0 0 7 6v2H4v14h8.26A6.995 6.995 0 0 1 18 11M9 6c0-1.66 1.34-3 3-3s3 1.34 3 3v2H9zm9 7c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5m1.65 7.35L17.5 18.2V15h1v2.79l1.85 1.85z" />
  </svg>
);
export default SvgLockClock;
